import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/scenario-evaluation-template-action-types';

import type {List, Map} from 'immutable';

export type ScenarioEvaluationTemplateStore = {
    activity: List<unknown>;
    evaluationTemplate: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        activity: Immutable.List(),
        evaluationTemplate: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_EVALUATION_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evaluationTemplate: action.data,
        };
    },
    [actionTypes.GET_EVALUATION_TEMPLATE_ACTIVITY_SUCCESS]: (state, action) => {
        return {
            activity: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioEvaluationTemplateStore>(initialState(), actionsMap);
